import React from 'react';
import Popup from "./Popup";

type PassportVerificationInfoPopupProps = {
    onClose: () => void;
}

export const PassportVerificationInfoPopup: React.FC<PassportVerificationInfoPopupProps> = ({ onClose }) => (
    <Popup onClose={onClose}>
        <div className="security-info-popup">
            <h3 className="H3_21">Как работает проверка паспорта?</h3>
            
            <div className="security-section">
                <h4 className="Subheader_17">Процесс проверки</h4>
                <p>
                    Проверка осуществляется так же как и в личном кабинете госуслуг. 
                    Система автоматически проверяет действительность паспорта по базе данных МВД. 
                    Функция работает только для российских паспортов.
                </p>
                <p>
                    При подписании договора у подписанта будет проверяться:
                </p>
                <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '10px'}}>
                    <li>Серия и номер паспорта</li>
                    <li>Фамилия и имя</li>
                </ul>
            </div>

            <div className="security-section">
                <h4 className="Subheader_17">Возможные результаты проверки</h4>
                <ul style={{listStyleType: 'none', padding: 0}}>
                    <li style={{marginBottom: '10px', color: '#4EBA28'}}>
                        ✅ Паспорт действителен (условно человека с таким паспортом посадят в самолет)
                    </li>
                    <li style={{marginBottom: '10px', color: '#E22631'}}>
                        ❌ Паспорт не найден или фамилия не совпадает с серией и номером
                    </li>
                    <li style={{marginBottom: '10px', color: '#E22631'}}>
                        ❌ Паспорт не действителен (украден, просрочен и прочее)
                    </li>
                </ul>
            </div>

            <div className="security-section">
                <h4 className="Subheader_17">Что происходит при неуспешной проверке?</h4>
                <p>
                    Если паспорт подписанта не прошел проверку:
                </p>
                <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '10px'}}>
                    <li>Договор будет переведен в статус "Ожидает проверки"</li>
                    <li>Вы получите уведомление о том, что паспорт не прошел проверку</li>
                </ul>
            </div>
        </div>
    </Popup>
); 